import { Button, Col, Container, Row } from "react-bootstrap";

import { Notificacion } from "@components/general/Alertas/Alertas";
import React from "react";
import { reactivateConsejo } from "@helpers/httpRequests/httpRequestsConsejos/httpRequestsConsejos";

const ReactivarConsejo = ({ setConsejoReactivado, consejo }) => {
  const { idConsejoRapido } = consejo;

  const cancelarReactivarConsejo = () => {
    Notificacion("info", "No se reactivó el consejo");
    setConsejoReactivado(true);
  };

  const reactivarConsejo = async (e) => {
    try {
      const { message } = await reactivateConsejo(idConsejoRapido);
      setConsejoReactivado(true);
      Notificacion("success", message);
    } catch (error) {
      Notificacion("error", "Error al desactivar el consejo");
    }
  };

  return (
    <Container fluid className="text-center">
      <h3>¿Estás seguro de reactivar el consejo seleccionado?</h3>

      <Row className="pt-3">
        <Col>
          <Button variant="success" onClick={reactivarConsejo}>
            Sí, reactivar
          </Button>
        </Col>

        <Col>
          <Button variant="danger" onClick={cancelarReactivarConsejo}>
            No, cancelar
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default ReactivarConsejo;
